import { ActionType } from '../../constants/ActionTypes';

export default function countdownsReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_COUNTDOWNS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case ActionType.GET_COUNTDOWNS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case ActionType.GET_COUNTDOWNS_SUCCESS:
            return {
                ...state,
                loading: false,
                contdownsData: action.payload.data
            }
        case ActionType.DELETE_COUNTDOWN_BEGIN:
        case ActionType.CHANGE_COUNTDOWN_VISIBILITY_BEGIN:
            return {
                ...state,
                loading: true,
            }
        case ActionType.DELETE_COUNTDOWN_ERROR:
        case ActionType.CHANGE_COUNTDOWN_VISIBILITY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case ActionType.DELETE_COUNTDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                contdownsData: Array.isArray(state.contdownsData)
                    ? state.contdownsData.filter((countdown) => countdown.id !== action.payload)
                    : state.contdownsData
            }
        case ActionType.CHANGE_COUNTDOWN_VISIBILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                contdownsData: Array.isArray(state.contdownsData)
                    ? state.contdownsData.map((countdown) => (
                        action.payload.id === countdown.id
                            ? { ...countdown, isVisible: action.payload.isVisible }
                            : countdown
                    ))
                    : state.contdownsData
            }
        case ActionType.CREATE_COUNTDOWN_BEGIN:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case ActionType.CREATE_COUNTDOWN_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case ActionType.CREATE_COUNTDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                contdownsData: Array.isArray(state.contdownsData)
                    ? [action.payload, ...state.contdownsData]
                    : [action.payload]
            }

        default:
            return state;
    }
}